import { render } from "./CustomizeModal.vue?vue&type=template&id=5dd39096"
import script from "./CustomizeModal.vue?vue&type=script&lang=js"
export * from "./CustomizeModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ricpp/Development/boldbrush/blog_post_editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__